import { render, staticRenderFns } from "./PickedUpList.vue?vue&type=template&id=59cbe84d"
import script from "./PickedUpList.vue?vue&type=script&lang=js"
export * from "./PickedUpList.vue?vue&type=script&lang=js"
import style0 from "./PickedUpList.vue?vue&type=style&index=0&id=59cbe84d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports